<template>
    <jin-dialog v-model="visible" custom-class="ushk-report-dialog" size="large" width="80%">
      <div slot="title" class="ushk-report-dialog__title">{{ data.name }}</div>
      <report-content v-if="visible" :type="type" :data="data" border/>
    </jin-dialog>
  </template>
  
  <script>
  
  export default {
    name: '',
    props: {
      data: Object,
      type: String,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: this.value
      }
    },
    watch: {
      value (v) {
        this.visible = v
      },
      visible (v) {
        this.$emit('input', v)
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// ReportDialog.vue?71401c10